import { brandConfiguration } from "@/brands/config";
import { getFeaturesEnabled } from "@/utils";
import { AdSlotIds } from "@/shared/types";
const { ads: advertising } = brandConfiguration;
export const useIsPubstackEnabled = () => {
    var _a;
    const { pubstack } = getFeaturesEnabled();
    const adUrlHasPubstack = (_a = advertising === null || advertising === void 0 ? void 0 : advertising.optimizationScriptUrl) === null || _a === void 0 ? void 0 : _a.includes("pbstck");
    return pubstack && adUrlHasPubstack;
};
export const filterAdSlots = (adSlots, options) => {
    const { isFarbweltActive, isAdLeaderboardHidden } = options;
    const { showOptionalAdsWithFarbwelt } = getFeaturesEnabled();
    /** to avoid yieldLove issue */
    /** define slots that will not be defined during first load */
    const dynamicAdSlots = [AdSlotIds.AD_MASONRY, AdSlotIds.AD_CAROUSEL]; // those slots are not loaded directly but refresh when their dom container is available
    const alwaysFarbweltAdSlots = [
        AdSlotIds.PARTNERBOX_1_COMMERCIAL,
        AdSlotIds.PARTNERBOX_2_COMMERCIAL,
        AdSlotIds.PARTNERBOX_3_TOOLS_AND_SERVICE,
        AdSlotIds.PARTNERBOX_4_TOOLS_AND_SERVICE,
        AdSlotIds.PARTNERBOX_5_TOOLS_AND_SERVICE,
        AdSlotIds.RENTAL_LINK,
    ];
    const optionalFarbweltAdSlots = [
        AdSlotIds.AD_CAROUSEL,
        AdSlotIds.AD_MASONRY,
        AdSlotIds.AD_MEDIUM_RECTANGLE_2,
    ];
    if (isFarbweltActive) {
        if (showOptionalAdsWithFarbwelt) {
            return adSlots.filter((ad) => [...alwaysFarbweltAdSlots, ...optionalFarbweltAdSlots].includes(ad.id));
        }
        else {
            return adSlots.filter((ad) => alwaysFarbweltAdSlots.includes(ad.id));
        }
    }
    return adSlots.filter((ad) => {
        if (dynamicAdSlots.includes(ad.id))
            return false;
        if (isAdLeaderboardHidden && ad.id === AdSlotIds.AD_LEADERBOARD)
            return false;
        return true;
    });
};
export const createSlotRenderEndedListener = (setLoadedSlot) => {
    const slotStatus = {};
    return (event) => {
        const slotId = event.slot.getSlotElementId();
        // Avoid overwriting if already marked as loaded
        // because yieldLove and Pubstack also fire slotRenderEnded event
        // and we don't want to overwrite the status and avoid conflict
        // If the slot is already loaded, exit early
        if (slotStatus[slotId] === "loaded")
            return;
        // Update the status of the slot
        // If the slot is empty, mark it as "failed"
        // Otherwise, mark it as "loaded"
        const status = event.isEmpty ? "failed" : "loaded";
        slotStatus[slotId] = status;
        setLoadedSlot(slotId, status);
    };
};
